import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlSignature } from '../common/apiEndpoint';
import { LoginService } from '../login/login.service';
import { Person } from './person';

@Injectable()
export class PersonService {
  $personName = new EventEmitter();
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
    private loginService: LoginService,
  ) {}

  getPersonById(personId: string): Observable<Person> {
    const url = this.urlSignature.personByIdUrl + personId;
    return this.httpClient.get(url).pipe(map((response) => response as Person));
  }
}
